import { render } from "./BotUI.vue?vue&type=template&id=f5c9c01e&lang=pug"
import script from "./BotUI.vue?vue&type=script&lang=js"
export * from "./BotUI.vue?vue&type=script&lang=js"

import "../assets/scss/_app.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__